import ResponsivePhotoCapture from "./ResponsivePhotoCapture";
import { IntakeData } from "../../pages/Index";

interface PhotoCaptureStepProps {
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onNext: () => void;
}

export default function PhotoCaptureStep({ data, onUpdate, onNext }: PhotoCaptureStepProps) {
  return (
    <ResponsivePhotoCapture
      data={data}
      onUpdate={onUpdate}
      onNext={onNext}
    />
  );
}
